module.exports = __webpack_public_path__ + "fonts/sole.9f4f3bc.eot";